
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 121 163","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.5 129.307c26.403 0 47.807-21.404 47.807-47.807 0-26.403-21.404-47.807-47.807-47.807-26.403 0-47.807 21.404-47.807 47.807 0 26.403 21.404 47.807 47.807 47.807zm0 4.693c28.995 0 52.5-23.505 52.5-52.5S89.495 29 60.5 29 8 52.505 8 81.5 31.505 134 60.5 134z","fill":"#0E193F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.672 94.888a4.381 4.381 0 100-8.763 4.381 4.381 0 000 8.763zm0 4.692a9.074 9.074 0 100-18.148 9.074 9.074 0 000 18.148zM86.41 94.888a4.381 4.381 0 100-8.763 4.381 4.381 0 000 8.763zm0 4.692a9.074 9.074 0 100-18.148 9.074 9.074 0 000 18.148zM60.626 107.231a8.27 8.27 0 100-16.54 8.27 8.27 0 000 16.54zm0 4.693c7.16 0 12.963-5.804 12.963-12.963 0-7.16-5.804-12.963-12.963-12.963-7.16 0-12.963 5.804-12.963 12.963 0 7.159 5.804 12.963 12.963 12.963zM78.126 72.23a8.27 8.27 0 100-16.54 8.27 8.27 0 000 16.54zm0 4.693c7.159 0 12.962-5.804 12.962-12.963 0-7.16-5.803-12.963-12.962-12.963-7.16 0-12.963 5.804-12.963 12.963 0 7.16 5.803 12.963 12.963 12.963zM43.126 72.23a8.27 8.27 0 100-16.54 8.27 8.27 0 000 16.54zm0 4.693c7.16 0 12.963-5.804 12.963-12.963 0-7.16-5.804-12.963-12.963-12.963-7.16 0-12.963 5.804-12.963 12.963 0 7.16 5.804 12.963 12.963 12.963z","fill":"#0E193F"}})])
          )
        }
      }
    